<template>
  <div class="merchantDetail">
    <el-drawer
      size="920px"
      title="核算单详情"
      :data="visible"
      :visible.sync="visible"
      :before-close="cancelModal"
      :wrapperClosable="false"
    >
      <div ref="accountSheet" class="pages">
        <div class="block-header">
          <div class="top">
            <img src="@/static/zflogo.png" alt="" />
            <span> 核算单 </span>
          </div>
          <ul class="info">
            <li>
              <label>结算单号：</label>
              <span>{{ accountForm.settleNo }}</span>
            </li>
            <li>
              <label>结算申请人：</label>
              <span>{{ accountForm.agentName }}</span>
            </li>
            <li>
              <label>项目名称：</label>
              <span>{{ accountForm.projectName }}</span>
            </li>
            <!-- <li>
                  <label>申请结算车数：</label>
                  <span>{{accountForm.waybillCnt}}</span>
                </li> -->
            <li>
              <label>运单数：</label>
              <span>{{ accountForm.settleCnt }}</span>
            </li>
            <li>
              <label>结算金额：</label>
              <span>{{ accountForm.settleAmt }}</span>
            </li>
            <li>
              <label>核算人：</label>
              <span>{{ accountForm.settleName }}</span>
            </li>
          </ul>
        </div>

        <div
          class="table"
          v-for="(item, index) in waybillData.body"
          :key="index"
        >
          <div class="tableTitle">
            <span>承运人:{{ item.carrier_name }}</span
            ><span class="red">共计{{ item.cnt }}车，{{ item.amt }}元</span>
          </div>

          <div class="inner" v-for="(list, k) in item.detail" :key="k + 100">
            <div class="tableTitle" style="background: #fff;border-bottom: none;">
              <span>{{ list.create_datetime }}</span
              ><span class="red"
                >共计{{ list.cnt }}车，{{ list.total_amt }}元</span
              >
            </div>
            <el-table :data="list.detailDetail" border class="table">
              <el-table-column
                property="truckCode"
                width="100px"
                label="车牌号"
              ></el-table-column>
              <el-table-column
                property="settleCnt"
                label="运单数"
                align="center"
              ></el-table-column>
              <el-table-column
                property="weightTons"
                label="总数量"
                align="center"
              ></el-table-column>
              <el-table-column
                property="weightUnit"
                label="单位"
              ></el-table-column>
              <el-table-column
                property="settlePrice"
                label="单价"
                align="center"
              ></el-table-column>
              <el-table-column
                property="payeePrice"
                label="预付价总额"
                align="center"
              ></el-table-column>
              <el-table-column
                property="totalAmt"
                label="核算价总额"
                align="center"
              ></el-table-column>
            </el-table>
          </div>
        </div>
        <ul class="info1">
          <div class="left">
            <div class="label">甲方签名：</div>
            <div class="value">日期：</div>
          </div>
          <div class="right">
            <div class="label">乙方签名：</div>
            <div class="value">日期：</div>
          </div>
        </ul>
      </div>
      <div class="footer">
        <!-- <div class="left"> -->
          <el-button
            type="primary"
            plain
            size="small"
            @click="downExport"
            class="custom-btn"
          >
            导出</el-button
          >
          <el-button
            type="primary"
            plain
            :loading="loading"
            class="custom-btn"
            size="small"
            @click="printPDF"
          >
            下载PDF打印</el-button
          >
        <!-- </div> -->
        <!-- <div class="right">
          <el-button size="small" @click="cancelModal"> 取消</el-button>
          <el-button type="primary" size="small" @click="cancelModal">
            确定</el-button
          >
        </div> -->
      </div>
     
    </el-drawer>
    <!-- 弹窗 -->
    <el-dialog
      width="70%"
      title="运单详情"
      :visible="dialogVisible"
      :before-close="closeDialog"
      :close-on-click-modal="false"
    >
      <div class="table" style="margin-top: 20px">
        <el-table :data="tableData" border :loading="loading">
          <el-table-column
            property="no"
            min-width="100px"
            label="运单号"
          ></el-table-column>
          <el-table-column
            property="agentName"
            min-width="100px"
            label="项目合作方"
          ></el-table-column>
          <el-table-column
            property="truckCode"
            min-width="100px"
            label="车牌号"
          ></el-table-column>
          <el-table-column property="tpMode" min-width="100px" label="运输方式">
            <template slot-scope="scope">
              <div>{{ filterTpMode(scope.row.tpMode) }}</div>
            </template>
          </el-table-column>
          <el-table-column
            property="garbageName"
            min-width="100px"
            label="泥尾"
          ></el-table-column>
          <el-table-column
            property="goSoilType"
            min-width="100px"
            label="土质"
          ></el-table-column>
          <el-table-column
            property="captainName"
            label="车队长"
          ></el-table-column>
          <el-table-column property="driverName" label="司机"></el-table-column>
          <el-table-column
            property="inStaffName"
            min-width="100px"
            label="挖机签单员"
          ></el-table-column>
          <el-table-column
            property="goStaffName"
            min-width="100px"
            label="出场签单员"
          ></el-table-column>
          <el-table-column
            property="load"
            min-width="100px"
            label="容量"
          ></el-table-column>
          <el-table-column
            property="inDatetime"
            min-width="120px"
            label="挖机签单时间"
          ></el-table-column>
          <el-table-column
            property="goDatetime"
            min-width="120px"
            label="出场签单时间"
          ></el-table-column>
          <el-table-column
            property="completeDatetime"
            min-width="120px"
            label="完成时间"
          ></el-table-column>
          <el-table-column
            property="settlePrice"
            min-width="100px"
            label="结算价"
          ></el-table-column>
          <el-table-column
            property="exAmt"
            min-width="100px"
            label="异常金额"
          ></el-table-column>
          <el-table-column
            property="adjustAmt"
            min-width="100px"
            label="增减值"
          ></el-table-column>
          <el-table-column
            property="goRemark"
            min-width="100px"
            label="备注"
          ></el-table-column>
          <el-table-column
            property="weightTons"
            min-width="100px"
            label="重量(吨)"
          ></el-table-column>
          <el-table-column
            property="isReject"
            min-width="100px"
            label="是否驳回"
          >
            <template slot-scope="scope">
              <div>{{ scope.row.isReject == 1 ? "是" : "否" }}</div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { clearNoNum } from "@/util/util.js";
import {
  printWaybillDetail,
  downloadSettlePdf,
} from "@/api/chain/companysettle";
import $Print from "avue-plugin-print";
import { print } from "@/util/util.js";
import { expotOut } from "@/util/down.js";
export default {
  props: {
    //弹窗状态
    visible: {
      type: Boolean,
      default: false,
    },
    //结算数据
    accountForm: {},
  },
  data() {
    return {
      loading: false,
      dialogVisible: false,
      waybillData: this.accountForm.tableData,
      tableData: [],
    };
  },
  mounted() {},
  methods: {
    /* ------------------------------------------------------- 下载PDF打印 ----------------------------------------------------- */
    printPDF() {
      this.loading = true;
      let params = {
        settleId: this.accountForm.id,
      };
      downloadSettlePdf(params)
        .then((res) => {
          console.log(res);
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement("a");
          link.href = url;
          let fileName = "结算单.pdf"; //
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    /* ------------------------------------------------------- 下载exc ----------------------------------------------------- */
    downExport() {
      let params = {
        settleId: this.accountForm.id,
      };
      let url = "/chain/companysettle/exportExcelSettle";
      expotOut(params, url, "结算单");
    },
    /* ------------------------------------------------------- 取消查看核算 ----------------------------------------------------- */
    cancelModal() {
      this.$emit("update:visible", false);
    },
    /* ------------------------------------------------------- 关闭弹窗 ----------------------------------------------------- */
    closeDialog() {
      this.dialogVisible = false;
    },
    /* ------------------------------------------------------- 查看运单 ----------------------------------------------------- */
    toWaybill(row, item) {
      let param = {
        settleId: this.accountForm.id,
        settleDate: item.create_datetime,
        truckId: row.truck_id,
      };
      this.tableData = [];
      this.loading = true;
      printWaybillDetail(param)
        .then((res) => {
          this.loading = false;
          this.dialogVisible = true;
          this.tableData = res.data.data;
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.info {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  // border-bottom: 1px solid #ccc;
  padding: 20px;
  li {
    width: 33.3%;
    line-height: 25px;
    label {
      display: inline-block;
      // width: 116px;
      font-weight: 500;
      font-size: 14px;
      color: #313133;
    }
    span {
      font-weight: 400;
      font-size: 14px;
      color: #313133;
    }
  }
}
.isClick {
  color: #409eff;
  cursor: pointer;
  display: block;
  text-decoration: underline;
}
/deep/ .el-drawer__header {
  margin-bottom: 0px;
  padding: 11px 20px;
  border-bottom: 1px solid #ededf0;
  span {
    font-weight: 400;
    font-size: 14px;
    color: #313133;
  }
}
/deep/ .el-drawer__body {
  padding: 0px;
  // padding-bottom: 70px;
  #accountSheet {
    padding: 0 20px;
  }
  .demo-drawer__footer {
    width: 100%;
    text-align: center;
    background-color: rgba(204, 204, 204, 0.7);
    border-radius: 6px;
    line-height: 60px;
    position: absolute;
    bottom: 10px;
  }
}
.tableTitle {
  border: 1px solid #edeff0;
  // margin-left: 1px;
  border-top: none;
  // border-bottom: none;
  // line-height: 32px;
  // padding: 0px 10px;
  // color: #606266;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #f5f8fa;
  padding: 13px 20px;
  span {
    font-weight: 500;
    font-size: 16px;
    color: #313133;
  }
  .red {
  font-weight: 500;
  font-size: 14px;
  color: #35b1ff;
}
}

/deep/ .el-table {
  // border-bottom: 1px solid #EDEFF0;
  // border-right: 1px solid #EDEFF0;
  tr {
    .el-table__cell {
      // border-left: 1px solid #EDEFF0;
      // border-top: 1px solid #EDEFF0;
    }
    border-right: 1px solid #EDEFF0;
  }
  .el-table__row {
    td {
      padding: 4px 0px;
    }
  }
  .el-table__header {
    th {
      padding: 4px 0px;
    }
  }
}
.block-header {
  border: 1px solid #edeff0;

  .top {
    line-height: 65px;
    height: 65px;
    position: relative;
    border-bottom: 2px solid #999999;
    span {
      font-weight: 500;
      font-size: 20px;
      color: #313133;
      text-align: center;
      text-decoration: underline;
      display: flex;
      justify-content: center;
    }
  }
  img {
    position: absolute;
    left: 20px;
    top: 20px;
    width: 78px;
    height: 28px;
  }
}
.pages {
  margin: 32px;
}
/deep/.el-table__header th.is-leaf{
  background: #fff!important;
}
.el-table__header th.is-leaf{
  border:  1px solid #EDEFF0;;
}
.info1 {
  display: flex;
  justify-content: space-between;
  // border-bottom: 1px solid #ccc;
  // padding-bottom: 10px;
  margin: 40px 0;
  padding: 0 20px;
  margin-bottom: 26px;
  .left,.right {
    font-weight: 400;
    font-size: 14px;
    color: #313133;
    .label {
      font-weight: 500;
      font-size: 16px;
      color: #313133;
      margin-bottom: 14px;
    }
    .value{
      font-weight: 400;
    font-size: 14px;
    color: #313133;
    }
  }
  .right{
    margin-right: 100px;
  }
  li {
    text-align: left;
    margin-left: 20px;
    width: 50%;
    font-weight: 400;
    font-size: 14px;
    color: #313133;
    margin-bottom: 14px;
    label {
      display: inline-block;
      width: 96px;
    }
    span {
      color: #666;
    }
  }
}
.footer {
  padding: 16px 24px;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  border-top: 1px solid #ededf0;
  background: #fff;
}
.custom-btn {
  background: #fff !important;
  &:hover {
    color: #35b1ff !important;
  }
}
</style>
